import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/icon/pack-up.png'


const _hoisted_1 = {
  class: "chat",
  style: {"flex-direction":"row","display":"flex"}
}
const _hoisted_2 = { style: {"overflow-y":"auto","border-left":"1px solid #d9d9d9","width":"100%"} }

import { ref, onMounted, onUnmounted, computed, watchEffect } from '../../adapter-vue';
import TUIChatEngine, {
  TUITranslateService,
  TUIConversationService,
  TUIStore,
  StoreName,
  IMessageModel,
  IConversationModel,
} from '@tencentcloud/chat-uikit-engine';
import TUICore, { TUIConstants, ExtensionInfo } from '@tencentcloud/tui-core';
import ChatHeader from './chat-header/index.vue';
import MessageList from './message-list/index.vue';
import MessageInput from './message-input/index.vue';
import MultipleSelectPanel from './mulitple-select-panel/index.vue';
import Forward from './forward/index.vue';
import MessageInputToolbar from './message-input-toolbar/index.vue';
import { isPC, isWeChat, isUniFrameWork, isMobile } from '../../utils/env';
import { ToolbarDisplayType } from '../../interface';
import TUIChatConfig from './config';
import { getCustomerCustomersApi } from '@/utils/user';
import UserSituation from './message-list/user-situation/index.vue';
import quickLanguageStore from '@/store/modules/quickLanguage'
import { Toast, TOAST_TYPE } from '@/TUIKit/components/common/Toast';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  userID: {
    type: String,
    default: '',
    required: false,
  }
},
  emits: ['closeChat'],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const groupID = ref(undefined);
const userProfile = ref({});
const isGroup = ref(false);
const isNotInGroup = ref(false);
const notInGroupReason = ref<number>();
const currentConversationID = ref();
const isMultipleSelectMode = ref(false);
const inputToolbarDisplayType = ref<ToolbarDisplayType>('none');
const messageInputRef = ref();
const messageListRef = ref<InstanceType<typeof MessageList>>();
const headerExtensionList = ref<ExtensionInfo[]>([]);
const featureConfig = TUIChatConfig.getFeatureConfig();

const props = __props;

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdate,
    currentConversation: onCurrentConversationUpdate,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdate,
    currentConversation: onCurrentConversationUpdate,
  });
  reset();
});

const isInputToolbarShow = computed<boolean>(() => {
  return isUniFrameWork ? inputToolbarDisplayType.value !== 'none' : true;
});

const leaveGroupReasonText = computed<string>(() => {
  let text = '';
  switch (notInGroupReason.value) {
    case 4:
      text = TUITranslateService.t('TUIChat.您已被管理员移出群聊');
      break;
    case 5:
      text = TUITranslateService.t('TUIChat.该群聊已被解散');
      break;
    case 8:
      text = TUITranslateService.t('TUIChat.您已退出该群聊');
      break;
    default:
      text = TUITranslateService.t('TUIChat.您已退出该群聊');
      break;
  }
  return text;
});

const reset = () => {
  TUIConversationService.switchConversation('');
};

const closeChat = (conversationID: string) => {
  emits('closeChat', conversationID);
  reset();
};

const insertEmoji = (emojiObj: object) => {
  messageInputRef.value?.insertEmoji(emojiObj);
};

const handleEditor = (message: IMessageModel, type: string) => {
  if (!message || !type) return;
  switch (type) {
    case 'reference':
      // todo
      break;
    case 'reply':
      // todo
      break;
    case 'reedit':
      if (message?.payload?.text) {
        messageInputRef?.value?.reEdit(message?.payload?.text);
      }
      break;
    default:
      break;
  }
};

const handleGroup = () => {
  headerExtensionList.value[0].listener.onClicked({ groupID: groupID.value });
};

function changeToolbarDisplayType(type: ToolbarDisplayType) {
  inputToolbarDisplayType.value = inputToolbarDisplayType.value === type ? 'none' : type;
  if (inputToolbarDisplayType.value !== 'none' && isUniFrameWork) {
    uni.$emit('scroll-to-bottom');
  }
}

function scrollToLatestMessage() {
  messageListRef.value?.scrollToLatestMessage();
}

function toggleMultipleSelectMode(visible?: boolean) {
  isMultipleSelectMode.value = visible === undefined ? !isMultipleSelectMode.value : visible;
}

function mergeForwardMessage() {
  messageListRef.value?.mergeForwardMessage();
}

function oneByOneForwardMessage() {
  messageListRef.value?.oneByOneForwardMessage();
}

function onCurrentConversationUpdate(conversation: IConversationModel) {
  console.log('conversation: ', conversation)
  userProfile.value = conversation?.userProfile || {};
  if (conversation?.operationType > 0) {
    headerExtensionList.value = [];
    isNotInGroup.value = true;
    /**
     * 4 - be removed from the group
     * 5 - group is dismissed
     * 8 - quit group
     */
    notInGroupReason.value = conversation?.operationType;
  } else {
    isNotInGroup.value = false;
    notInGroupReason.value = undefined;
  }
}

function onCurrentConversationIDUpdate(conversationID: string) {
  if (currentConversationID.value === conversationID) {
    return;
  }

  isGroup.value = false;
  let conversationType = TUIChatEngine.TYPES.CONV_C2C;
  if (conversationID.startsWith(TUIChatEngine.TYPES.CONV_GROUP)) {
    conversationType = TUIChatEngine.TYPES.CONV_GROUP;
    isGroup.value = true;
    groupID.value = conversationID.replace(TUIChatEngine.TYPES.CONV_GROUP, '');
  }

  headerExtensionList.value = [];
  currentConversationID.value = conversationID;
  isMultipleSelectMode.value = false;
  // Initialize chatType
  TUIChatConfig.setChatType(conversationType);
  // While converstaion change success, notify callkit and roomkit、or other components.
  TUICore.notifyEvent(TUIConstants.TUIChat.EVENT.CHAT_STATE_CHANGED, TUIConstants.TUIChat.EVENT_SUB_KEY.CHAT_OPENED, { groupID: groupID.value });
  // The TUICustomerServicePlugin plugin determines if the current conversation is a customer service conversation, then sets chatType and activates the conversation.
  TUICore.callService({
    serviceName: TUIConstants.TUICustomerServicePlugin.SERVICE.NAME,
    method: TUIConstants.TUICustomerServicePlugin.SERVICE.METHOD.ACTIVE_CONVERSATION,
    params: { conversationID: conversationID },
  });
  // Get chat header extensions
  if (TUIChatConfig.getChatType() === TUIConstants.TUIChat.TYPE.GROUP) {
    headerExtensionList.value = TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.CHAT_HEADER.EXT_ID);
  }
}



// 右侧侧边栏
const quickLanguage = quickLanguageStore()

const isShowRightDatail = ref(false)
const userDetail:any = ref({})
const getUserDatail = async ()=>{
  isShowRightDatail.value = false
  quickLanguage.hide() //关闭快捷语弹窗
  try {
    const result = await getCustomerCustomersApi({
      imUserId: userProfile.value.userID,
      pageNum: 1,
      pageSize: 10,
    })

    const data = result?.body?.list[0] || {};
    userDetail.value = data;

    isShowRightDatail.value = true
  } catch (error) {
    Toast({
      message: error?.head?.msg || '获取失败',
      type: TOAST_TYPE.ERROR,
    });
  }
}


watchEffect(()=>{
  isShowRightDatail.value = false
  if(userProfile.value.userID){
    isShowRightDatail.value = true
    getUserDatail()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5'])
    }, [
      (!_unref(currentConversationID))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['tui-chat-default', !_unref(isPC) && 'tui-chat-h5-default'])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2))
        : _createCommentVNode("", true),
      (_unref(currentConversationID))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5'])
          }, [
            _createVNode(ChatHeader, {
              class: _normalizeClass([
            'tui-chat-header',
            !_unref(isPC) && 'tui-chat-H5-header',
            _unref(isUniFrameWork) && 'tui-chat-uniapp-header',
          ]),
              headerExtensionList: _unref(headerExtensionList),
              onCloseChat: closeChat
            }, null, 8, ["class", "headerExtensionList"]),
            _createVNode(Forward, { onToggleMultipleSelectMode: toggleMultipleSelectMode }),
            _createVNode(MessageList, {
              ref_key: "messageListRef",
              ref: messageListRef,
              class: _normalizeClass(['tui-chat-message-list', !_unref(isPC) && 'tui-chat-h5-message-list']),
              isGroup: _unref(isGroup),
              groupID: _unref(groupID),
              userID: props.userID,
              currentConversationID: _unref(currentConversationID),
              isNotInGroup: _unref(isNotInGroup),
              isMultipleSelectMode: _unref(isMultipleSelectMode),
              userProfile: _unref(userProfile),
              onHandleEditor: handleEditor,
              onCloseInputToolBar: _cache[0] || (_cache[0] = () => changeToolbarDisplayType('none')),
              onToggleMultipleSelectMode: toggleMultipleSelectMode
            }, null, 8, ["class", "isGroup", "groupID", "userID", "currentConversationID", "isNotInGroup", "isMultipleSelectMode", "userProfile"]),
            (_unref(isNotInGroup))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({
            'tui-chat-leave-group': true,
            'tui-chat-leave-group-mobile': _unref(isMobile),
          })
                }, _toDisplayString(_unref(leaveGroupReasonText)), 3))
              : (_unref(isMultipleSelectMode))
                ? (_openBlock(), _createBlock(MultipleSelectPanel, {
                    key: 1,
                    onOneByOneForwardMessage: oneByOneForwardMessage,
                    onMergeForwardMessage: mergeForwardMessage,
                    onToggleMultipleSelectMode: toggleMultipleSelectMode
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_unref(isInputToolbarShow))
                      ? (_openBlock(), _createBlock(MessageInputToolbar, {
                          key: 0,
                          class: _normalizeClass([
              'tui-chat-message-input-toolbar',
              !_unref(isPC) && 'tui-chat-h5-message-input-toolbar',
              _unref(isUniFrameWork) && 'tui-chat-uni-message-input-toolbar'
            ]),
                          displayType: _unref(inputToolbarDisplayType),
                          onInsertEmoji: insertEmoji,
                          onChangeToolbarDisplayType: changeToolbarDisplayType,
                          onScrollToLatestMessage: scrollToLatestMessage
                        }, null, 8, ["class", "displayType"]))
                      : _createCommentVNode("", true),
                    _createVNode(MessageInput, {
                      ref_key: "messageInputRef",
                      ref: messageInputRef,
                      class: _normalizeClass([
              'tui-chat-message-input',
              !_unref(isPC) && 'tui-chat-h5-message-input',
              _unref(isUniFrameWork) && 'tui-chat-uni-message-input',
              _unref(isWeChat) && 'tui-chat-wx-message-input',
            ]),
                      enableAt: _unref(featureConfig).InputMention,
                      isMuted: false,
                      muteText: _unref(TUITranslateService).t('TUIChat.您已被管理员禁言'),
                      placeholder: _unref(TUITranslateService).t('TUIChat.请输入消息'),
                      inputToolbarDisplayType: _unref(inputToolbarDisplayType),
                      onChangeToolbarDisplayType: changeToolbarDisplayType
                    }, null, 8, ["class", "enableAt", "muteText", "placeholder", "inputToolbarDisplayType"])
                  ], 64))
          ], 2))
        : _createCommentVNode("", true),
      (!_unref(isNotInGroup) && _unref(isUniFrameWork) && _unref(isGroup) && _unref(headerExtensionList).length > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "group-profile",
            onClick: handleGroup
          }, _toDisplayString(_unref(headerExtensionList)[0].text), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: "right-container",
      style: _normalizeStyle({'min-width' : _unref(isShowRightDatail) && _unref(userDetail).id ? '675px' : 'auto', paddingRight: '20px'})
    }, [
      (_unref(userDetail).id)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["expand-collapse", {'rotate-180': !_unref(isShowRightDatail)}]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isShowRightDatail.value = !_unref(isShowRightDatail)))
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]))], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_unref(isShowRightDatail) && _unref(userDetail).id)
          ? (_openBlock(), _createBlock(UserSituation, {
              key: 0,
              userDetail: _unref(userDetail)
            }, null, 8, ["userDetail"]))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
}
}

})